/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ link: NonNullable<unknown>, code: NonNullable<unknown> }} Invite_Share_Text_LinkInputs */

const en_us2_invite_share_text_link = /** @type {(inputs: Invite_Share_Text_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I'm training with MyPocketGym. Join me: ${i?.link} (invite ${i?.code})`)
};

const pt_br2_invite_share_text_link = /** @type {(inputs: Invite_Share_Text_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estou treinando com o MyPocketGym. Vem também: ${i?.link} (convite ${i?.code})`)
};

const pt_pt2_invite_share_text_link = /** @type {(inputs: Invite_Share_Text_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estou treinando com o MyPocketGym. Vem também: ${i?.link} (convite ${i?.code})`)
};

/** @type {(inputs: Invite_Share_Text_LinkInputs) => LocalizedString} */
const es_419_invite_share_text_link = en_us2_invite_share_text_link;

/** @type {(inputs: Invite_Share_Text_LinkInputs) => LocalizedString} */
const fr_fr2_invite_share_text_link = en_us2_invite_share_text_link;

/** @type {(inputs: Invite_Share_Text_LinkInputs) => LocalizedString} */
const de_de2_invite_share_text_link = en_us2_invite_share_text_link;

/** @type {(inputs: Invite_Share_Text_LinkInputs) => LocalizedString} */
const it_it2_invite_share_text_link = en_us2_invite_share_text_link;

/**
* | output |
* | --- |
* | "I'm training with MyPocketGym. Join me: {link} (invite {code})" |
*
* @param {Invite_Share_Text_LinkInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_share_text_link = /** @type {((inputs: Invite_Share_Text_LinkInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Share_Text_LinkInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_share_text_link(inputs)
	if (locale === "es-419") return es_419_invite_share_text_link(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_share_text_link(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_share_text_link(inputs)
	if (locale === "de-DE") return de_de2_invite_share_text_link(inputs)
	if (locale === "it-IT") return it_it2_invite_share_text_link(inputs)
	return en_us2_invite_share_text_link(inputs)
});
export { invite_share_text_link as "invite.share_text_link" }